// 结薪配置类型
export enum submitTypes {
  AnchorSubmitAnchor = 1, // 主播结薪方式-主播提交
  AgencySubmitAnchor = 2, // 主播结薪方式-代理提交、经纪人提交
  AgentSubmitAgent = 3, // 代理结薪方式-代理提交
}

// 支付方式 1:自提，2:代收，3-银行转账
export enum paymentMethodTypes {
  myself = 1,
  other = 2,
  bankcard = 3,
}

// 上报
export enum USER_ACTION {
  // 1=by beans method曝光
  // 2=by beans method点击
  // 3=点击add数据
  // 4=add弹窗--点击ok
  // 5=add弹窗--点击cancel
  // 6=payment_method入口曝光
  // 7=payment_method入口点击
  // 8=payment_method弹窗--点击ok
  // 9=payment_method弹窗--点击cancel"
  byBeansMethodExpose = 1,
  byBeansMethodClick,
  addClick,
  addOkClick,
  addCancelClick,
  paymentMethodExpose,
  paymentMethodClick,
  paymentMethodOkClick,
  paymentMethodCancelClick,
}
